import { API_BASE_URL, buildQuery, requestJson } from "./apiClient";

function analyticsPath(clientViewId, segment = "") {
  return `/api/admin/client-views/${clientViewId}/analytics${segment}`;
}

export function getClientViewAnalytics(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId)}${buildQuery(params)}`);
}

export function getAnalyticsSummary(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/summary")}${buildQuery(params)}`);
}

export function getAnalyticsTraffic(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/traffic")}${buildQuery(params)}`);
}

export function getAnalyticsSearches(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/searches")}${buildQuery(params)}`);
}

export function getAnalyticsListings(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/listings")}${buildQuery(params)}`);
}

export function getAnalyticsLeads(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/leads")}${buildQuery(params)}`);
}

export function getAnalyticsConversions(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/conversions")}${buildQuery(params)}`);
}

export function getAnalyticsMarket(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/market")}${buildQuery(params)}`);
}

export function getAnalyticsCampaigns(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/campaigns")}${buildQuery(params)}`);
}

export function getAnalyticsTimeOnMarket(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/time-on-market")}${buildQuery(params)}`);
}

export function rebuildAnalytics(clientViewId, body) {
  return requestJson(`${analyticsPath(clientViewId, "/rebuild")}`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function exportAnalyticsReport(clientViewId, params = {}) {
  const query = buildQuery(params);
  const response = await fetch(
    `${API_BASE_URL}${analyticsPath(clientViewId, "/export")}${query}`,
    { credentials: "include" }
  );
  if (!response.ok) {
    const body = await response.json().catch(() => ({}));
    throw new Error(body.message || "Export failed");
  }
  if (params.format === "csv") {
    return response.text();
  }
  return response.json();
}

export function getGa4AnalyticsStatus(clientViewId) {
  return requestJson(`${analyticsPath(clientViewId, "/ga4/status")}`);
}

export function updateGa4AnalyticsSettings(clientViewId, payload) {
  return requestJson(`${analyticsPath(clientViewId, "/ga4")}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  });
}

export function getGa4AnalyticsSummary(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/ga4/summary")}${buildQuery(params)}`);
}

export function getGa4AnalyticsTraffic(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/ga4/traffic")}${buildQuery(params)}`);
}

export function getGa4AnalyticsEngagement(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/ga4/engagement")}${buildQuery(params)}`);
}

export function getGa4AnalyticsEvents(clientViewId, params = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/ga4/events")}${buildQuery(params)}`);
}

export function syncGa4Analytics(clientViewId, body = {}) {
  return requestJson(`${analyticsPath(clientViewId, "/ga4/sync")}`, {
    method: "POST",
    body: JSON.stringify(body),
  });
}
